(function () {
  var config = window.__ccuConfig || {};
  var TRIGGER_PRODUCT_IDS = (config.triggerProductIds || []).map(Number).filter(Boolean);
  var COMBO_PRODUCT_ID = config.comboProductId || 0;

  function getCard() {
    return document.querySelector('[data-ccu-card]');
  }

  function cartHasProduct(cart, productId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === productId) return true;
    }
    return false;
  }

  function cartHasAnyTriggerProduct(cart) {
    for (var i = 0; i < TRIGGER_PRODUCT_IDS.length; i++) {
      if (cartHasProduct(cart, TRIGGER_PRODUCT_IDS[i])) return true;
    }
    return false;
  }

  function cartHasComboProduct(cart) {
    return cartHasProduct(cart, COMBO_PRODUCT_ID);
  }
  function findComboLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === COMBO_PRODUCT_ID) return cart.items[i];
    }
    return null;
  }

  function refreshCardVisibility() {
    if (TRIGGER_PRODUCT_IDS.length === 0 || !COMBO_PRODUCT_ID) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var card = getCard();
        if (!card) return;

        var triggerPresent = cartHasAnyTriggerProduct(cart);
        var comboLine = findComboLine(cart);

        // Auto-remove the combo item if the trigger product (Pull-Ons) is no longer in cart
        if (comboLine && !triggerPresent) {
          fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: comboLine.key, quantity: 0 })
          }).then(function () {
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.refreshCartDrawer === 'function') {
              cartDrawer.refreshCartDrawer();
            }
          });
          return;
        }

        card.hidden = !(triggerPresent && !comboLine);
      });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-ccu-add-button]');
    if (!addBtn) return;

    var variantId = addBtn.getAttribute('data-ccu-variant-id');
    var content = addBtn.querySelector('.ccu-card__add-content');
    var spinner = addBtn.querySelector('.ccu-card__add-spinner');

    addBtn.disabled = true;
    if (content) content.hidden = true;
    if (spinner) spinner.hidden = false;

    var cartDrawer = document.querySelector('cart-drawer');
    var sectionIds = (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-combo-upsell', cartData: response });
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          var isClosedCart = !document.body.classList.contains('page-overlay-cart-on');
          cartDrawer.renderContents(response, isClosedCart);
        }
      })
      .finally(function () {
        addBtn.disabled = false;
        if (content) content.hidden = false;
        if (spinner) spinner.hidden = true;
      });
  });

  document.addEventListener('cart:updated', refreshCardVisibility);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCardVisibility);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCardVisibility);
  } else {
    refreshCardVisibility();
  }
})();